import {Box, Typography} from "@material-ui/core";
import React from "react";

const calendarEvent = (eventInfo:any) => {
    console.log('calendarEvent:',eventInfo);
    const {event} = eventInfo;
    return (
        <Box style={{
            backgroundColor: event?.extendedProps?.dcolor || '#fff',
            width:'100%'
        }}>
             <Typography style={{
                 textOverflow: 'ellipsis',
                 overflow: 'hidden',
                 whiteSpace: 'nowrap'
             }}>{(!event?.title || event?.title === "")?"No Title": event?.title}</Typography>
        </Box>
    )
}

export default calendarEvent;